<ng-container *ngIf="rollingAvgChartOptions$ | async as chartOptions">
  <ng-container *ngIf="chartOptions.shouldRenderChart">
    <mat-card class="container-nps">
      <mat-card-header class="nps-rolling-graph-header">
        <mat-card-title class="nps-rolling-graph-title">
          {{ 'NPS_ROLLING_AVG_GRAPH.TITLE' | translate }}
        </mat-card-title>
        <div class="nps-tool-tip">
          <div [glxyPopover]="popover" (mouseenter)="showPopovers()" (mouseleave)="hidePopovers()">
            <mat-icon class="info-icon">info_outline</mat-icon>
          </div>
          <glxy-popover
            #popover
            [isOpen]="showPopover"
            [maxWidth]="'400px'"
            [positions]="[PopoverPositions.Bottom, PopoverPositions.BottomRight]"
          >
            {{ 'NPS_ROLLING_AVG_GRAPH.NPS_INFO' | translate }}
          </glxy-popover>
        </div>
      </mat-card-header>
      <mat-card-content class="nps-rolling-graph-content">
        <apx-chart
          [series]="chartOptions.series"
          [chart]="chartOptions.chart"
          [colors]="chartOptions.colors"
          [dataLabels]="chartOptions.dataLabels"
          [stroke]="chartOptions.stroke"
          [xaxis]="chartOptions.xaxis"
          [yaxis]="chartOptions.grid.yaxis"
          [markers]="chartOptions.markers"
          [tooltip]="chartOptions.tooltip"
          [fill]="chartOptions.fill"
          [grid]="chartOptions.grid"
        ></apx-chart>
      </mat-card-content>
    </mat-card>
  </ng-container>
</ng-container>
